import _ from 'lodash';

export function getQueryString(patentId: string) {
    const search = (location.search || '').slice(1);
    const queryObj = new URLSearchParams(search);

    const q = queryObj.get('q');
    const uk = queryObj.get('uk');
    const bio_uk = queryObj.get('bio_uk');
    const from_site = queryObj.get('from_site');
    const view_type = queryObj.get('view_type');
    const workspace_id = queryObj.get('workspace_id');
    const folder_id = queryObj.get('folder_id');
    const source_type = queryObj.get('source_type');
    const ws_view_type = queryObj.get('ws_view_type');
    const _type = queryObj.get('_type');

    const urlParams = _.omitBy({
        patentId,
        q,
        uk,
        bio_uk,
        from_site,
        _type,
        view_type,
        workspace_id,
        folder_id,
        source_type,
        ws_view_type,
    }, item => !item) as Record<string, string>;

    return new URLSearchParams(urlParams).toString();
}
